



































































































































































































































































































import { Component } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./purchase-order-columns";
import opsColumns from "./ops-purchase-order-columns";
import clientColumns from "./client-purchase-order-columns";
import AppConsts from "@/lib/appconst";
import Customer from "@/store/entities/customers/customer";
import _ from "lodash";

class PagePurchaseOrderRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  status: string;
  warehouseCode: string;
  from: Date;
  to: Date;
  type: string;
  customerId: number;
  conditionTypeCode: string;
  productKeyword: string;
  containerKeyword: string;
}
@Component
export default class PurchaseOrder extends mixins(ListMixin, AbpBase) {
  namespace = "purchaseOrder";
  spinShow: boolean = false;
  //filters
  pagerequest: PagePurchaseOrderRequest = new PagePurchaseOrderRequest();
  creationTime: Date[] = [];
  types = [];
  customerLoading: boolean = false;
  customers: Array<Customer> = new Array<Customer>();
  customer: Customer = new Customer();
  conditionTypes = [];
  clients = [];
  warehouses = [];
  statuses = [];
  get store() {
    return this.$store.state.purchaseOrder;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  isNewPo() {
    return AppConsts.poStatus.new;
  }
  validToUpdate(po) {
    if (this.isClient()) {
      return (
        po.status === AppConsts.poStatus.new &&
        po.type === AppConsts.poTypes.standard
      );
    }
    return (
      po.status === AppConsts.poStatus.new &&
      (po.type === AppConsts.poTypes.standard ||
       po.type === AppConsts.poTypes.returnSalesOrder ||
        po.type === AppConsts.poTypes.returnSalesOrderAfterPack ||
        po.Type === AppConsts.poTypes.returnOrderHTH ||
        po.type === AppConsts.poTypes.crmReturnOrder)
    );
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.pagerequest.clientCode = re.length === 0 ? "" : re[0].code;
        this.clients = re;
      });
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListStatusForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.status,
          prefix: AppConsts.tableRef.tablePo.prefix.status,
          hasAllItem: true,
        },
      })
      .then(() => {
        var re = this.$store.state.purchaseOrder.statuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.statuses = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListTypeForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.type,
          prefix: AppConsts.tableRef.tablePo.prefix.type,
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.types = re;
        this.pagerequest.type =
          this.types.length === 0 ? "" : this.types[0].code;
      });
  }
  async getConditionTypes() {
    await this.$store
      .dispatch({
        type: "masterData/getFeatureConditionTypesForSelect",
        data: {
          featureCode: AppConsts.featureConditionType.PO_Create,
          hasAllItem: true,
        },
      })
      .then((re) => {
        this.conditionTypes = re;
        this.pagerequest.conditionTypeCode =
          this.conditionTypes.length === 0 ? "" : this.conditionTypes[0].id;
      });
  }
  importPurchaseOrders() {
    this.$router.push({ path: "import-purchaseorder" });
  }
  get list() {
    var re = this.$store.state.purchaseOrder.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (this.creationTime.length > 0) {
      this.pagerequest.from = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.to = this.creationTime[1];
    }
  }
  renderColumn() {
    if (this.isClient()) {
      return clientColumns.concat(columns);
    }
    if (this.isTenant()) {
      return opsColumns.concat(columns);
    }
    return opsColumns.concat(clientColumns).concat(columns);
  }
  get columns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      ...this.renderColumn(),
      {
        title: this.L("Action"),
        width: 120,
        slot: "action",
        align: "center",
      },
    ];
  }
  async created() {
    this.spinShow = true;
    try {
      await this.getClients();
      await this.getWarehouses();
      await this.getStatuses();
      await this.getTypes();
      await this.getConditionTypes();
      var defaultDate = new Date();
      this.creationTime = [defaultDate, defaultDate];
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  updated() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode =
        this.$store.state.session.tenant.tenancyName;
    }
  }
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }
}
